import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminOffers = lazy(() => import("@/pages/admin/AdminOffers"));

export const Route = createFileRoute("/admin/annonsorer")({
  component: () => <AdminOffers />,
});
